/* global jwplayer */
import React from 'react';
import Jwplayer from './MediaPlayer/Jwplayer';
import Utils from '../Utils/Utils';

export default class Live extends React.Component {

  async componentDidMount() {
    window.sdk.on('monitorStream', (isLive) => {
      console.log('isLive')
      if(isLive) {
        setTimeout(() => {
          if(!window.sdk.player().getState() != 'playing')
            window.sdk.player().reload()
        }, 10000)
      }
    })
    
    if(window.slide_url != '') {
      this.showMedia()
    }
    
    window.sdk.on('media_change', (data) => {
      console.log('media_change')
      if(data.url != window.slide_url) {
        window.slide_url = data.url;
        this.showMedia();
      }
    })
    
  }
  
  async showMedia() {
    while(!document.querySelector('#player video')) {
      await Utils.sleep(300);
    }
    
    document.querySelector('.jw-slider-time').style.display = 'none';
    document.querySelector('.jw-icon-rewind').style.display = 'none';
    
    if(!document.getElementById('synople_media')) {
      let el = document.querySelector('#player video');
      el.classList.add('withMedia')
      var node = document.createElement('div');
      node.id = 'synople_media'
      el.parentNode.appendChild(node)
    }
    else {
      var node = document.getElementById('synople_media');
    }
    node.innerHTML = '<div><img src="/public/' + window.programId   + '/' + window.slide_url + '" /></div>';
  }

  render() {
    
    if (window.sdk.isOdjOnly())
      window.sdk.live.streamUrl = '/public/novideo5.mp4'; //window.sdk.isByPassUrl();
   
    return (
      <Jwplayer streamingUrl={  window.sdk.live.streamUrl } />
    );
  }

}



// WEBPACK FOOTER //
// ./src/Player/Live.js